import { render, staticRenderFns } from "./closeIcon.vue?vue&type=template&id=b740c3b8&"
import script from "./closeIcon.vue?vue&type=script&lang=ts&"
export * from "./closeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b740c3b8', component.options)
    } else {
      api.reload('b740c3b8', component.options)
    }
    module.hot.accept("./closeIcon.vue?vue&type=template&id=b740c3b8&", function () {
      api.rerender('b740c3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/closeIcon.vue"
export default component.exports